import React from 'react';
import { Info, Lock, Coins } from 'lucide-react';
import { CREDIT_COSTS } from '../services/stripeService';
import './UsageBanner.css';

const UsageBanner = ({ used = 0, limit = 0, label = 'uses', creditBalance = 0, feature, onUpgrade, onBuyCredits }) => {
    if (limit === Infinity || limit >= 999999) return null; // Unlimited — don't show banner

    const ratio = limit > 0 ? used / limit : 0;
    const isNearLimit = ratio >= 0.8;
    const isAtLimit = used >= limit;
    const remaining = Math.max(0, limit - used);
    const isCreditEligible = feature && !!CREDIT_COSTS[feature];
    const creditCost = CREDIT_COSTS[feature] || 0;

    return (
        <div className={`usage-banner ${isAtLimit ? 'at-limit' : isNearLimit ? 'near-limit' : ''}`}>
            <div className="usage-banner-left">
                {isAtLimit ? <Lock size={14} /> : <Info size={14} />}
                <span className="usage-text">
                    {isAtLimit ? (
                        isCreditEligible && creditBalance >= creditCost ? (
                            <>{label} limit reached. Will use credits.</>
                        ) : (
                            <>{label} limit reached</>
                        )
                    ) : (
                        <><strong>{remaining}</strong> {label} remaining</>
                    )}
                </span>
                {isCreditEligible && creditBalance > 0 && isAtLimit && (
                    <span className="credit-balance-tag">
                        <Coins size={12} />
                        {creditBalance} credits
                    </span>
                )}
            </div>

            <div className="usage-bar-container">
                <div
                    className={`usage-bar-fill ${isAtLimit ? 'full' : isNearLimit ? 'warning' : ''}`}
                    style={{ width: `${Math.min(100, ratio * 100)}%` }}
                />
            </div>

            <span className="usage-count">{used}/{limit}</span>

            {isAtLimit && (
                isCreditEligible && creditBalance < creditCost && onBuyCredits ? (
                    <button className="usage-credits-btn" onClick={onBuyCredits}>
                        <Coins size={12} /> Buy Credits
                    </button>
                ) : onUpgrade && !isCreditEligible ? (
                    <button className="usage-upgrade-btn" onClick={onUpgrade}>
                        Upgrade
                    </button>
                ) : null
            )}
        </div>
    );
};

export default UsageBanner;
